module.exports = __webpack_public_path__ + "img/fast_bg.f5dacec8.png";